import { render, staticRenderFns } from "./AccountingProductManageDialog.component.vue?vue&type=template&id=fbd3dfc4"
import script from "./AccountingProductManageDialog.component.vue?vue&type=script&lang=js"
export * from "./AccountingProductManageDialog.component.vue?vue&type=script&lang=js"
import style0 from "./AccountingProductManageDialog.component.vue?vue&type=style&index=0&id=fbd3dfc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports